import { useEffect } from 'react';
import { HashRouter as Router} from 'react-router-dom';
import Proutes from './common/router';
import { UpdaterProvider } from './components/UpdaterProvider';
import { applyPersistedBaseUrl } from './utlilities/config';

function App() {
  useEffect(() => {
    applyPersistedBaseUrl();
  }, []);

  return (
    <UpdaterProvider>
      <Router>
        <Proutes/>
      </Router>
    </UpdaterProvider>
   
  );
}

export default App;
